import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import SearchableInput from 'components/common/SearchableInput';

import { productNameApi, channelProductApi } from 'api';

const ProductLinkModal = ({ show, onHide, product, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleClose = () => {
    setSelectedProduct(null);
    setError(null);
    onHide();
  };

  const handleLinkNow = async () => {
    if (selectedProduct) {
      setIsLoading(true);
      try {
        await channelProductApi.linkProduct(product.id, {
          product_id: selectedProduct.id,
        });

        // fetch table data
        onSuccess?.();
        handleClose();
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (!product) return null;

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Product Link</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-3">
          <div className="mb-3">
            <strong>Channel:</strong> {product?.channel?.channel_type}
          </div>
          <div className="mb-3">
            <strong>Name:</strong> {product.channel_product_name}
          </div>
          <div className="mb-3">
            {`${product?.channel_product_key} (${
              product?.channel_product_sku ? product?.channel_product_sku : '-'
            })`}
          </div>

          <SearchableInput
            apiService={productNameApi}
            searchField="search__icontains"
            placeholder="Enter 2 or more characters to search products..."
            onSelect={setSelectedProduct}
            renderItem={item => <div className="font-medium">{item?.name}</div>}
            visibleItems={2}
          />

          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleLinkNow}
          disabled={!selectedProduct || isLoading}
        >
          {isLoading ? 'Linking...' : 'Link Now'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductLinkModal;
